import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';

import ActionSheet from 'components/ActionSheet';

import SortingOptions from 'components/SortingOptions';

import { COLLECTION_SORT_OPTIONS } from '../../constants';

export const SortingComponentDesktop = ({ currentSortingOption, onSortOrderChange }) => (
  <React.Fragment>
    <SortingOptions
      zIndex={999999}
      sortingOptionClickHandler={onSortOrderChange}
      selected={{
        orderBy: currentSortingOption.key,
        orderByDirection: currentSortingOption.direction,
      }}
      options={COLLECTION_SORT_OPTIONS}
    />
  </React.Fragment>
);

SortingComponentDesktop.propTypes = {
  currentSortingOption: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }).isRequired,
  onSortOrderChange: PropTypes.func.isRequired,
};

const renderActionSheetSort = ({ currentSortingOption, handleSortOptionChange }) => (
  <List disablePadding>
    {COLLECTION_SORT_OPTIONS.map(option => (
      <ListItem key={option.key} onClick={() => handleSortOptionChange(option)}>
        <ListItemText>{option.label}</ListItemText>
        {currentSortingOption.key === option.key && (
          <ListItemIcon>
            <CheckIcon fontSize="medium" color="primary" />
          </ListItemIcon>
        )}
      </ListItem>
    ))}
  </List>
);

renderActionSheetSort.propTypes = {
  currentSortingOption: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }).isRequired,
  handleSortOptionChange: PropTypes.func.isRequired,
};

export const SortingComponentMobile = ({ currentSortingOption, onSortOrderChange }) => {
  const [showActionSheet, setShowActionSheet] = useState(false);

  const handleSortOptionChange = option => {
    onSortOrderChange(option);
    setShowActionSheet(false);
  };
  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => setShowActionSheet(!showActionSheet)}
      >
        Sort
      </Button>
      {showActionSheet && (
        <ActionSheet
          withCloseButton
          itemRenderer={() =>
            renderActionSheetSort({ currentSortingOption, handleSortOptionChange })
          }
          visible
          onClose={() => setShowActionSheet(false)}
        />
      )}
    </React.Fragment>
  );
};
SortingComponentMobile.propTypes = {
  currentSortingOption: PropTypes.shape({
    orderBy: PropTypes.string,
    orderByDirection: PropTypes.string,
  }).isRequired,
  onSortOrderChange: PropTypes.func.isRequired,
};
